// extracted by mini-css-extract-plugin
export var creditCallout = "creditCallout-module--creditCallout--4b77d";
export var logoWrap = "creditCallout-module--logoWrap--987d9";
export var slideUp = "creditCallout-module--slideUp--46310";
export var slideUpLarge = "creditCallout-module--slideUpLarge--302b6";